import angular from 'angular';

const themesServices = angular.module('applicationModule.themesServices', []);

themesServices.factory('Theme', ['ThemeAPI', function (ThemeAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return ThemeAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },

        get: function (themeId, appId) {
            return ThemeAPI.get(themeId, appId);
        },
        post: function (theme) {
            return ThemeAPI.createTheme(theme);
        },
        save: function (theme, editMode) {
            if (editMode) {
                return ThemeAPI.editTheme(theme);
            } else {
                return ThemeAPI.createTheme(theme);
            }
        },
        remove: function (themeId) {
            return ThemeAPI.remove(themeId);
        }
    };
}]);

themesServices.service('ThemeAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/themes/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {appId: appId})});
    };

    this.get = function (themeId, appId) {
        return $http.get(API_URL + themeId, {params: {appId: appId}});
    };

    this.createTheme = function (theme) {
        return $http.post(API_URL, theme);
    };

    this.editTheme = function (theme) {
        return $http.put(API_URL + theme.id, theme);
    };

    this.remove = function (themeId) {
        return $http.delete(API_URL + themeId);
    };
}]);

export default themesServices;
